<div>
  <div>
    <a class="id37-link" (click)="goToFriend()">{{friendName}}</a>
    <span> {{__('message')}}</span>
  </div>
  <span>{{customText}}</span>
</div>
